import { computed, ref, readonly } from 'vue';
import { StoreResources } from 'ihunter-common';
import { useFirebaseDatabase } from './useFirebaseDatabase';

const promotions = ref(null);
let loadingPromise = null;

export function usePromotions() {
    const { getData } = useFirebaseDatabase();

    async function load() {
        if (!loadingPromise) {
            loadingPromise = getData(StoreResources.Promotions())
                .then((data) => {
                    promotions.value = data;
                })
                .catch((error) => {
                    console.error('Failed to load promotions', error);
                    promotions.value = [];
                })
                .finally(() => {
                    loadingPromise = null;
                });
        }
        return loadingPromise;
    }

    if (!promotions.value && !loadingPromise) {
        void load(); // Fire and forget, don't await
    }

    const today = computed(() => {
        const now = new Date();
        return `${now.getFullYear()}-${`0${now.getMonth() + 1}`.slice(-2)}-${`0${now.getDate()}`.slice(-2)}`;
    });

    function isActivePromotion(promotion) {
        if (!promotion?.active) {
            return false;
        }

        if (promotion.start && promotion.start > today.value) {
            return false;
        }

        if (promotion.end && promotion.end < today.value) {
            return false;
        }

        return true;
    }

    const promoTagLine = computed(() => {
        if (!promotions.value) {
            return null;
        }
        for (const promotion of promotions.value) {
            if (isActivePromotion(promotion) && promotion.tagline) {
                return promotion.tagline;
            }
        }

        return null;
    });

    const promoCode = computed(() => {
        if (!promotions.value) {
            return null;
        }
        for (const promotion of promotions.value) {
            if (isActivePromotion(promotion) && promotion.code) {
                return promotion.code;
            }
        }

        return null;
    });

    return {
        promoTagLine,
        promoCode,
    };
}
